import React, { useState } from "react";
import UserLayout from "../../components/Layout/UserLayout";
import InnerHero from "../../components/InnerHero";

import "./style.css";

const TermsAndConditions = () => {
  const [key, setKey] = useState('home');
  return (
    <>
      <UserLayout>
        <InnerHero
          innerheroclass="aboutBg termscondition"
          title="Privacy Policy"
          column="col-md-12 text-center center-content about-sec"
        />


        <section className="termsbg">
          <div className="container">
            <div className="row">
              <div className="terms-text">
                <h2>Privacy Policy</h2>
                <p>At Falcon Book Writing, we respect your privacy and are committed to protecting the personal information you share with us. This Privacy Policy explains how we collect, use, store, protect, and disclose information when you visit our website, <a href="https://www.falconbookwriting.com/">www.falconbookwriting.com</a>, or use our book writing, ghostwriting, editing, publishing, illustration, and other related services.</p>
                <p>By accessing our website or using our services, you acknowledge that you have read and understood this Privacy Policy.</p>

                <h2>Information We Collect</h2>
                <p>We may collect different types of information when you visit our website, contact our team, submit an inquiry, or purchase our services.</p>

                <h2>Personal Information</h2>
                <p>When you complete a contact form, request a consultation, or communicate with us, we may collect:</p>
                <ul>
                    <li>Full name</li>
                    <li>Email address</li>
                    <li>Phone number</li>
                    <li>Project details and service requirements</li>
                    <li>Billing and payment-related information</li>
                    <li>Any other information you voluntarily provide</li>
                </ul>

                <h2>Project-Related Information</h2>
                <p>When you work with Falcon Book Writing, you may share materials necessary for completing your project, including:</p>
                <ul>
                    <li>Manuscripts and book drafts</li>
                    <li>Story ideas and outlines</li>
                    <li>Research materials and documents</li>
                    <li>Illustrations and design references</li>
                    <li>Publishing requirements</li>
                    <li>Author biographies and related content</li>
                </ul>
                <p>We use this information to understand your requirements and deliver the requested services.</p>

                <h2>Automatically Collected Information</h2>
                <p>When you access our website, certain technical information may be collected automatically, including:</p>
                <ul>
                    <li>IP address</li>
                    <li>Browser type and version</li>
                    <li>Device information</li>
                    <li>Operating system</li>
                    <li>Pages visited and browsing activity</li>
                    <li>Date and time of website visits</li>
                    <li>Referring website addresses</li>
                </ul>
                <p>This information helps us understand website usage and maintain website functionality.</p>

                <h2>How We Use Your Information</h2>
                <p>Falcon Book Writing uses collected information for legitimate business and service-related purposes, including:</p>
                <ul>
                    <li>Responding to inquiries and consultation requests.</li>
                    <li>Communicating with clients about their projects.</li>
                    <li>Providing book writing, ghostwriting, editing, and publishing services.</li>
                    <li>Preparing proposals, quotations, and service agreements.</li>
                    <li>Processing payments and managing transactions.</li>
                    <li>Understanding project requirements and preferences.</li>
                    <li>Improving website functionality and user experience.</li>
                    <li>Sending relevant service updates and administrative notifications.</li>
                    <li>Sharing promotional information where permitted by applicable law.</li>
                    <li>Maintaining business records and preventing fraudulent activities.</li>
                    <li>Complying with applicable legal obligations.</li>
                </ul>
                <p>We only use personal information for purposes that are relevant to our business operations and the services requested by our clients.</p>

                <h2>Cookies and Tracking Technologies</h2>
                <p>Our website may use cookies and similar tracking technologies to improve browsing functionality and understand visitor interactions.</p>
                <p>Cookies are small text files stored on your device when you visit a website.</p>
                <p>We may use cookies for purposes such as:</p>
                <ul>
                    <li>Remembering website preferences.</li>
                    <li>Understanding website traffic and visitor behavior.</li>
                    <li>Improving website performance.</li>
                    <li>Identifying technical issues.</li>
                    <li>Supporting website functionality and marketing activities.</li>
                </ul>
                <p>You can manage or disable cookies through your browser settings. However, disabling certain cookies may affect some website features.</p>
                <p>Where required by applicable law, we will request consent before using non-essential cookies or tracking technologies.</p>

                <h2>How We Share Your Information</h2>
                <p>Falcon Book Writing does not sell personal information to third parties.</p>
                <p>However, we may share relevant information with trusted third-party service providers when necessary to operate our business and deliver requested services.</p>
                <p>These providers may include:</p>
                <ul>
                    <li>Payment processing companies.</li>
                    <li>Website hosting and maintenance providers.</li>
                    <li>Email and communication service providers.</li>
                    <li>Marketing and analytics platforms.</li>
                    <li>Technical support providers.</li>
                    <li>Publishing and distribution platforms, when required for your project.</li>
                </ul>
                <p>We share only the information reasonably necessary for the relevant business purpose.</p>
                <p>Third-party providers may process information according to their own privacy policies and applicable contractual obligations.</p>
                <p>We may also disclose information when required by law, legal proceedings, regulatory authorities, or to protect our legal rights and business interests.</p>

                <h2>Protection of Your Information</h2>
                <p>We take reasonable administrative, technical, and organizational measures to protect personal information against unauthorized access, misuse, alteration, disclosure, or loss.</p>
                <p>Access to client information is limited to individuals and service providers who need it to perform their assigned responsibilities.</p>
                <p>Although we take reasonable precautions, no internet transmission or electronic storage method can be guaranteed to be completely secure. Therefore, we cannot promise absolute security of information transmitted through our website.</p>

                <h2>Confidentiality of Manuscripts and Project Materials</h2>
                <p>We understand that manuscripts, unpublished books, story concepts, and other creative materials may contain valuable and confidential information.</p>
                <p>Falcon Book Writing uses project materials for the purpose of providing the services requested by clients.</p>
                <p>We take reasonable steps to restrict access to these materials to authorized personnel and relevant service providers involved in project delivery.</p>
                <p>We do not intentionally publish or publicly distribute unpublished client manuscripts or project materials without appropriate authorization, except where disclosure is necessary to provide the requested services or is required by law.</p>
                <p>Clients should contact us if they have specific confidentiality requirements that need to be addressed in a separate written agreement.</p>

                <h2>Third-Party Websites and Services</h2>
                <p>Our website may contain links to external websites, platforms, or services. These third-party websites operate independently and may have their own privacy policies and data collection practices.</p>
                <p>Falcon Book Writing does not control the privacy practices, security procedures, or content of external websites.</p>
                <p>We encourage visitors to review the applicable privacy policies before submitting personal information to third-party platforms.</p>

                <h2>Data Retention</h2>
                <p>We retain personal information only for as long as reasonably necessary to fulfill the purposes described in this Privacy Policy.</p>
                <p>Information may be retained to:</p>
                <ul>
                    <li>Complete ongoing projects and provide requested services.</li>
                    <li>Maintain client and transaction records.</li>
                    <li>Address customer inquiries and disputes.</li>
                    <li>Meet applicable legal, accounting, and regulatory requirements.</li>
                    <li>Protect our legitimate business interests.</li>
                </ul>
                <p>When information is no longer required, we take reasonable steps to delete, destroy, or anonymize it, subject to applicable legal requirements and legitimate recordkeeping needs.</p>

                <h2>Your Privacy Rights and Choices</h2>
                <p>Depending on your location and applicable privacy laws, you may have certain rights concerning your personal information.</p>
                <p>These rights may include:</p>
                <ul>
                    <li><strong>Access:</strong> Request access to the personal information we maintain about you.</li>
                    <li><strong>Correction:</strong> Request corrections to inaccurate or incomplete information.</li>
                    <li><strong>Deletion:</strong> Request the deletion of personal information, subject to applicable legal exceptions.</li>
                    <li><strong>Withdrawal of Consent:</strong> Withdraw consent where processing is based on your consent.</li>
                    <li><strong>Marketing Preferences:</strong> Opt out of promotional emails and marketing communications.</li>
                    <li><strong>Data Portability:</strong> Request a copy of certain personal information in a commonly used format, where applicable.</li>
                    <li><strong>Restriction or Objection:</strong> Request restrictions on or object to certain types of data processing where applicable.</li>
                </ul>
                <p>To exercise any applicable privacy rights, please contact us using the email address provided below.</p>
                <p>We may need to verify your identity before processing certain requests.</p>

                <h2>Email Marketing and Communication</h2>
                <p>We may use the contact information you provide to send service-related updates, project notifications, important announcements, and other relevant communications.</p>
                <p>Where permitted by applicable law, we may also send promotional emails about our services and offers.</p>
                <p>You can opt out of promotional communications at any time by following the unsubscribe instructions included in the email or contacting us directly.</p>
                <p>Please note that opting out of promotional emails does not prevent us from sending essential service-related or transactional communications.</p>

                <h2>Children's Privacy</h2>
                <p>Our website and services are intended for a general audience and are not knowingly directed toward children under the age of 13.</p>
                <p>We do not knowingly collect personal information from children under 13 without the required parental consent.</p>
                <p>If we become aware that personal information has been collected from a child without appropriate authorization, we will take reasonable steps to delete that information.</p>
                <p>Parents or legal guardians who believe their child has submitted personal information to us may contact our team for assistance.</p>

                <h2>International Data Transfers</h2>
                <p>Falcon Book Writing may work with clients, service providers, and business partners located in different countries.</p>
                <p>As a result, personal information may be processed or stored in locations outside your country of residence.</p>
                <p>Where applicable, we take reasonable steps to ensure that international data transfers comply with relevant privacy and data protection requirements.</p>

                <h2>Changes to This Privacy Policy</h2>
                <p>Falcon Book Writing reserves the right to update or revise this Privacy Policy from time to time to reflect changes in our business practices, website functionality, services, or applicable legal requirements.</p>
                <p>Any updates will be published on this page along with the revised effective date.</p>
                <p>We encourage visitors to review this page periodically to stay informed about how their information is handled.</p>
                <p>Your continued use of our website following the publication of updates constitutes acknowledgment of the revised Privacy Policy, subject to any consent requirements under applicable law.</p>

                <h2>Contact Us</h2>
                <p>If you have questions, concerns, or requests regarding this Privacy Policy or the way we handle your personal information, please contact us:</p>
                <ul>
                    <li><strong>Company:</strong> Falcon Book Writing</li>
                    <li><strong>Website:</strong> <a href="https://www.falconbookwriting.com/">www.falconbookwriting.com</a></li>
                    <li><strong>Email:</strong> <a href="mailto:info@falconbookwriting.com">info@falconbookwriting.com</a></li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        

        
      </UserLayout>
    </>
  );
};

export default TermsAndConditions;
